import { Vue, prop, Options } from 'vue-class-component';
import { Button, ButtonTypes } from '@/components/button';
import { Icon, IconNames } from '@/components/icon';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { CoreModuleContext } from '@/store/core';
import { Routes } from '@/router/routes';
import styles from './top-bar.module.scss';

class TopBarProps {
	onLogin = prop<Function>({ default: () => () => undefined })

	onSave = prop<Function>({ default: () => () => undefined })

	onClose = prop<Function>({ default: () => () => undefined })
}

@Options({
	name: 'TopBar',
})
export class TopBar extends Vue.with(TopBarProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly coreModule!: CoreModuleContext;

	handleLogin() {
		this.onLogin();
	}

	get showSave() {
		if (this.$route) {
			return ![Routes.ERROR.name, Routes.CONTACT_US.name].includes(this.$route.name as string);
		}
		return false;
	}

	handleSave() {
		this.onSave();
		this.coreModule.actions.sendSaveEvent(this.$route.meta);
	}

	handleClose() {
		if (this.$route) {
			this.coreModule.actions.sendNavigationEvent({ routeDetails: this.$route.meta, triggerType: 'TopBarClose' });
		}
		this.onClose();
	}

	render() {
		// const loginButtonSlot = {
		// 	icon: () => <Icon name={ IconNames.userCircle } size={ 30 }/>,
		// };

		const closeButtonSlot = {
			icon: () => <Icon name={ IconNames.close } size={ 30 }/>,
		};

		return (
			<div class={ styles.topBar }>
				{/*<Button type={ ButtonTypes.link } inverted onClick={ this.handleLogin } v-slots={ loginButtonSlot }>*/}
				{/*	{ this.i18n.t('topBar.login') }*/}
				{/*</Button>*/}
				<div class={ styles.pushRight}>
					{ process.env.NODE_ENV === 'development' && <Button to="/dev" type={ ButtonTypes.link } inverted>
						Dev
					</Button> }
					{ this.showSave && <Button type={ButtonTypes.link} inverted onClick={this.handleSave}>
						{this.i18n.t('topBar.save')}
					</Button> }
				</div>
				<div class={ styles.topBarDivider }></div>
				<Button type={ ButtonTypes.link } inverted onClick={ this.handleClose } v-slots={ closeButtonSlot }>
				</Button>
			</div>
		);
	}
}
